"use client";

import { useEffect } from "react";
import { toast } from "@/components/ui/use-toast";
import {
  OAUTH_ERROR_PARAM,
  OAUTH_PLATFORM_PARAM,
  oauthErrorMessage,
} from "@/lib/platformConnectUrl";

/**
 * Shows why an ad-platform OAuth round trip didn't complete, on whichever
 * page it returned to (`completePlatformOAuth` puts a reason code in the
 * URL), then drops it so a refresh doesn't show it again.
 *
 * The return is a full page load from the platform, so reading the URL once
 * on mount is enough, and `window.location` keeps this out of the Suspense
 * boundary `useSearchParams` would need at the root.
 */
export function OAuthReturnNotice() {
  useEffect(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(OAUTH_ERROR_PARAM)) return;
    const message = oauthErrorMessage(
      url.searchParams.get(OAUTH_ERROR_PARAM),
      url.searchParams.get(OAUTH_PLATFORM_PARAM),
    );
    if (message) toast({ description: message });
    url.searchParams.delete(OAUTH_ERROR_PARAM);
    url.searchParams.delete(OAUTH_PLATFORM_PARAM);
    window.history.replaceState(window.history.state, "", url);
  }, []);
  return null;
}
